const updateCartItemsWindowArr = (callback) => {
  theme.cart.getCart().then((cart) => {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart: cart,
        },
      })
    );

    window.cartItems = cart.items;

    if (callback) {
      callback();
    }
  });
};

function getCart() {
  return fetch(window.theme.routes.cart)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      if (!error.description) {
        console.warn(error);
        return;
      }
    });
}

function setHelloRetailCartData(data) {
  var ids = data.items.map(function (item) {
    return item.product_id;
  });

  ADDWISH_PARTNER_NS.api.cart.setCart(
    {
      total: (data.total_price / 100).toString(),
      url: window.theme.routes.cartPage,
      productNumbers: ids.map(String),
      email: window.theme.customer.email ?? '',
    },
    function () {
      console.log('Cart has been tracked');
    }
  );
}

function setCartTracking(event) {
  if (!window.ADDWISH_PARTNER_NS) return;
  if (event?.detail?.cart) {
    setHelloRetailCartData(event.detail.cart);
  } else {
    getCart().then(function (data) {
      setHelloRetailCartData(data);
    });
  }
}

document.addEventListener('cart:updated', setCartTracking);
document.addEventListener('ajaxProduct:added', setCartTracking);
// document.addEventListener('cart:bundle-updated', setCartTracking);

// document.addEventListener('DOMContentLoaded', () => {
//   function selectCustomImage() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-selected');
//         wrapper.style.zIndex = '10';
//       } else {
//         wrapper.classList.remove('is-selected');
//         wrapper.style.zIndex = '1';
//       }
//     });
//   }

//     function selectCustomThumb() {
//     const imageWrappers = document.querySelectorAll('.product__thumb');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('.product__thumb img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-active');
//       } else {
//         wrapper.classList.remove('is-active');
//       }
//     });
//   }

//   function resetCustomImage() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');
//     imageWrappers.forEach(wrapper => {
//       wrapper.classList.remove('is-selected');
//       wrapper.style.zIndex = '1';
//     });
//   }
//     function resetCustomThumb() {
//     const thumbWrappers = document.querySelectorAll('.product__thumb');
//     thumbWrappers.forEach(wrapper => {
//       wrapper.classList.remove('is-active');
//     });
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.remove('is-selected');
//         wrapper.style.zIndex = '1';
//       } else {
//       }
//     });
//   }
//       function resetCustomThumbSlide() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-selected');
//         wrapper.style.zIndex = '10';
//       }
//     });
//   }
  
//   selectCustomImage();
//   selectCustomThumb();
  
//   document.addEventListener('click', (event) => {
//     const clickedElement = event.target;
//     if (clickedElement.closest('.variant-input img')) {
//       resetCustomImage();
//     }
//   });
//     document.addEventListener('click', (event) => {
//     const clickedElement = event.target;
//     if (clickedElement.closest('.product__thumb')) {
//        if (clickedElement.classList.contains('custom_image')) {
//          resetCustomThumbSlide();
//     } else {
//       resetCustomThumb();   
//     }
//     }
//   });
// });

$(document).ready(function () {
  const $gridProductsContainer = $('.grid');

  const insertHtmlIntoGrid = () => {
    const $gridProducts = $('.grid .grid-product');
    const $otherElements = $('#yarn-swatches .variant-colors');

    console.log('[InsertSwatches] Grid products found:', $gridProducts.length);
    console.log('[InsertSwatches] Swatch elements found:', $otherElements.length);

    if ($otherElements.length === 0) {
      console.warn('[InsertSwatches] No swatches found yet.');
      return;
    }

    $otherElements.each(function (_, element) {
      const $variantTitleEl = $(element).find('.variant-title');
      const variantTitle = $(element).data('title') || $variantTitleEl.text().trim();
      if (!variantTitle) return;

      $gridProducts.each(function (_, gridElement) {
        const $titleEl = $(gridElement).find('.grid-product__title');
        const productTitle = ($titleEl.data('originalTitle') || $titleEl.text()).trim();
        if (!productTitle || /Kit/i.test(productTitle)) return;

        const normalizedProductTitle = productTitle.toLowerCase();
        const normalizedVariantTitle = variantTitle.toLowerCase();

        if (normalizedProductTitle === normalizedVariantTitle) {
          const innerHtml = $(element).html();
          let $childElement = $(gridElement).find('.child-container');

          if ($childElement.length) {
            if ($childElement.html().indexOf(innerHtml) === -1) {
              $childElement.append(innerHtml);
              console.log(`[InsertSwatches] Appended swatches to: ${productTitle}`);
            }
          } else {
            $(gridElement).append(`<div class="child-container">${innerHtml}</div>`);
            console.log(`[InsertSwatches] Created swatch container for: ${productTitle}`);
          }
        }
      });
    });
  };

  // ✅ Wait until swatches actually load
  const swatchContainer = document.getElementById('yarn-swatches');
  if (swatchContainer) {
    const swatchObserver = new MutationObserver(() => {
      const $otherElements = $('#yarn-swatches .variant-colors');
      if ($otherElements.length > 0) {
        console.log('[InsertSwatches] Swatches detected, inserting...');
        swatchObserver.disconnect();
        insertHtmlIntoGrid();
      }
    });

    swatchObserver.observe(swatchContainer, { childList: true, subtree: true });
  }

  // ✅ Still watch grid changes
  if ($gridProductsContainer.length) {
    const observer = new MutationObserver(function () {
      console.log('[InsertSwatches] Grid changed, re-inserting swatches');
      insertHtmlIntoGrid();
    });

    observer.observe($gridProductsContainer[0], {
      childList: true,
      subtree: true,
    });
  }

  // ✅ Retry after filter clicks
  $(document).on('click', '.tag__checkbox, .tag--remove', function () {
    setTimeout(() => {
      console.log('[InsertSwatches] Re-inserting after filter');
      insertHtmlIntoGrid();
    }, 2000);
  });
});


const removeAfterLastHyphen = (el) => {
  const originalText = el.textContent;
  el.dataset.originalTitle = originalText;

  const lastHyphenIndex = originalText.lastIndexOf('-');
  if (lastHyphenIndex !== -1) {
    const trimmedText = originalText.substring(0, lastHyphenIndex).trim();
    el.textContent = trimmedText;
  }
};

const processTitles = () => {
  document.querySelectorAll('.collection-garn .grid-product__title').forEach(el => {
    if (!el.dataset.hyphenProcessed) {
      removeAfterLastHyphen(el);
      el.dataset.hyphenProcessed = "true";
    }
  });
};

processTitles();

const observer = new MutationObserver(() => {
  processTitles();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});